module.exports = __webpack_public_path__ + "assets/media/1.ff7232aa.wav";